export const PayBankBalanceZero = "PayBankBalanceZero";
export const VacationBankBalanceZero = "VacationBankBalanceZero";